<template>
    <div class="af-filter-tags-list-container">
        <div class="af-filter-tags-list-wrapper">
            <div :class="['af-filter-tags afu-mb-4', { 'af-filter-tags--reveal': searchbarTagsHide }]">
                <C1Tag
                    ref="searchBarTagsBox"
                    v-for="(attribute, index) in $_searchFilterTags"
                    :key="`${attribute.id}-${index}`"
                    removable
                    @remove="removeSearchFilterTag(attribute)"
                >
                    {{ attribute.value }}
                </C1Tag>
                <a
                    v-if="$_searchFilterTags.length"
                    class="af-filter-tags-clear afu-text-neutral-dark af-text--base afu-font-bold afu-ml-4 afu-no-underline"
                    href=""
                    @click.stop.prevent="resetSearch"
                >
                    {{ $t('filter.clear_all') }}
                </a>
            </div>
        </div>
        <div class="af-filter-tags-more">
            <a
                v-if="tagsOverflow"
                class="af-filter-tags-more-btn"
                href="#"
                @click.stop.prevent="toggelMoreTags"
            >
                <span v-if="searchbarTagsHide">
                    {{ $t('see_all_value', {'value': $_searchFilterTags.length}) }}
                    <FontAwesomeIcon
                        :icon="['far', 'angle-down']"
                        size="sm"
                        fixed-width
                    />
                </span>
                <span v-else>{{ $t('filter.see_less') }} <FontAwesomeIcon
                    :icon="['far', 'angle-up']"
                    size="sm"
                    fixed-width
                /></span>
            </a>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';
    import { Bus } from '@/utils/bus';
    import C1Tag from '@/components/C1Components/C1Tag';

    export default {
        name: 'FilterTagsList',

        components: {
            C1Tag,
        },

        data() {
            return {
                searchbarTagsHide: true,
                tagsOverflow: false,
            };
        },

        computed: {

            ...mapState({
                $_search: state => state.search,
            }),

            ...mapGetters('search', {
                $_searchFilterTags: 'getSearchFilterTags',
            }),

        },

        mounted() {
            this.searchbarTagsHide = this.$_search.searchbarTagsHide;
            this.checkOverflow();
        },

        updated() {
            this.checkOverflow();
        },

        methods: {

            ...mapMutations('search', {
                $_INIT_SEARCH_PAYLOAD: 'INIT_SEARCH_PAYLOAD',
                $_SET_SEARCH_FILTERS: 'SET_SEARCH_FILTERS',
                $_DELETE_SEARCH_TAG: 'DELETE_SEARCH_TAG',
            }),

            removeSearchFilterTag(attributeOption) {
                const key = attributeOption.attribute_code;
                if (key === 'pay_max' || key === 'pay_min') {
                    this.$_SET_SEARCH_FILTERS({ key: 'pay_max', value: {} });
                    this.$_SET_SEARCH_FILTERS({ key: 'pay_min', value: {} });
                    Bus.$emit('resetSalaryFilter');
                } else if (key === 'location') {
                    this.$store.commit('search/DELETE_LOCATION');
                } else if (key === 'posted_within_days' || key === 'industry' || key === 'search') {
                    this.$_SET_SEARCH_FILTERS({ key, value: '', preventSearch: true });
                } else if (key === 'search_keywords') {
                    this.$store.commit('search/DELETE_SEARCH_TAG');
                } else if (key === 'classifications') {
                    this.$store.commit('search/DELETE_CLASSIFICATION', { id: attributeOption.id });
                } else if (key === 'subclassifications') {
                    this.$store.commit('search/DELETE_SUB_CLASSIFICATION', { id: attributeOption.id });
                } else {
                    this.$store.commit('search/DELETE_SEARCH_FILTER_ATTRIBUTE', { key, attributeOption, preventSearch: true });
                }
                this.$store.commit('search/SET', { key: 'searchbarTagsHide', value: false });
                this.$emit('search');
            },

            resetSearch() {
                this.$_INIT_SEARCH_PAYLOAD();
                this.$_DELETE_SEARCH_TAG();
                this.$emit('search');
            },

            toggelMoreTags() {
                this.searchbarTagsHide = !this.searchbarTagsHide;
            },

            checkOverflow() {
                const searchBarTagsBox = this.$refs.searchBarTagsBox;
                if (searchBarTagsBox) {
                    const searchBarTagsHeight = searchBarTagsBox.clientHeight;
                    if (searchBarTagsHeight > 40) {
                        this.tagsOverflow = true;
                    } else {
                        this.tagsOverflow = false;
                    }
                }
            },
        },
    };
</script>
